import React, { useEffect, useMemo } from 'react';
import { useField } from 'formik';

import DateFieldCustom from 'components/Common/Formik/DateFieldCustom/DateFieldCustom';
import { ExtraStyleType } from 'components/Common/Formik/FieldCustom/FieldCustom';
import RadioFieldCustom, {
  OptionType,
} from 'components/Common/Formik/RadioFieldCustom/RadioFieldCustom';
import TextFieldCustom from 'components/Common/Formik/TextFieldCustom/TextFieldCustom';
import {
  newsletterFormFields,
  newsletterSubOptionsFormFields,
} from 'settings/fields/newsletter';

import styles from 'components/NewsletterPage/NewsletterPage.module.scss';

function NewsletterPersonalDetails(): JSX.Element {
  const [{ value: smsCheckedValue }] = useField('smsOption');
  const [, { error: isMobileError }, { setTouched }] = useField<string>(
    'cellPhone'
  );

  const extraStyle: ExtraStyleType = useMemo(
    () => ({
      container: styles.field,
      fieldContainer: styles.fieldContainer,
      label: styles.fieldLabel,
    }),
    []
  );

  const radioExtraStyle: ExtraStyleType = useMemo(
    () => ({
      container: `${styles.radioContainer} ${styles.field}`,
      fieldContainer: styles.radioFieldContainer,
      label: styles.radioFieldLabel,
    }),
    []
  );

  useEffect(() => {
    if ('1' === smsCheckedValue && isMobileError) {
      setTouched(true);
    }
  }, [smsCheckedValue, isMobileError]);

  return (
    <>
      <div className={styles.personalDetails}>
        {Object.entries(newsletterFormFields).map(([key, field]) => {
          const required =
            key === 'cellPhone' && '1' === smsCheckedValue
              ? true
              : field.required;

          if (key === 'civility') {
            return (
              <RadioFieldCustom
                key={key}
                label={field.label}
                name={field.name}
                options={field.options as OptionType[]}
                required={required}
                autoComplete={field.autoComplete as string}
                extraStyle={extraStyle}
              />
            );
          }

          if (field.type === 'date') {
            return (
              <DateFieldCustom
                key={key}
                label={field.label}
                name={field.name}
                autoComplete={field.autoComplete}
                extraStyle={extraStyle}
              />
            );
          }

          return (
            <TextFieldCustom
              key={key}
              label={field.label}
              name={field.name}
              required={required}
              autoComplete={field.autoComplete as string}
              extraStyle={extraStyle}
            />
          );
        })}
      </div>
      <div className={styles.otherFields}>
        {Object.values(newsletterSubOptionsFormFields).map(field => (
          <RadioFieldCustom
            key={field.name}
            label={field.label}
            name={field.name}
            options={field.options as OptionType[]}
            extraStyle={radioExtraStyle}
            required={field.required}
          />
        ))}
      </div>
    </>
  );
}

export default NewsletterPersonalDetails;
